<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { onBeforeMount } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useConfigStore } from "@core/stores/config.store"
import { DEFAULT_SCOPE_NAME } from "@core/constants/config"
import { useSubscriptionFormStore } from "@modules/abonnement/stores/subscription-form.store"

// ================================
// ROUTER & STORE
// ================================
const route = useRoute()
const router = useRouter()
const configStore = useConfigStore()
const subscriptionFormStore = useSubscriptionFormStore()

// ================================
// GUARD SCOPE & RESET APRÈS SUCCÈS STRIPE
// ================================
onBeforeMount(() => {
    if (configStore.scope?.name !== DEFAULT_SCOPE_NAME) {
        router.replace("/login")
        return
    }
    // Retour Stripe succès : réinitialiser le store et le brouillon pour empêcher de reprendre l'inscription
    const status = route.query.status as string | undefined
    const sessionId = route.query.session_id as string | undefined
    if (status === "success" && sessionId) {
        subscriptionFormStore.$reset()
    }
})
</script>

<template>
    <div class="page page-inscription min-h-screen max-w-screen-2xl! mx-auto">
        <SubscriptionForm />
    </div>
</template>
